export default __webpack_public_path__ + "static/studio-slider-11-a856d4d8a9dc5e55f915a54dd5e91c87.png";